import styled from "styled-components/native";

export const AppBackgroundContainer = styled.View`
  background-color: ${({ theme }) => theme.background};
  overflow: hidden;
  flex: 1;
`;
